import DealerInterface from '../interfaces/dealer.interface';

export default function hasActiveFilter(
    activeFilters: string[],
    dealer: DealerInterface
): boolean {
    if (!activeFilters.length) {
        return true;
    }

    const badges = dealer.badges;
    const authorizedIndex = activeFilters.indexOf('is_authorized');

    if (authorizedIndex !== -1 && !dealer.isAuthorized) {
        return false;
    }

    return Boolean(activeFilters.filter(item => item !== 'is_authorized').every(filter => badges.find(item => item.type === filter)));
}
